import { Component,  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'error',
  templateUrl: 'error.template.html'
})
export class ErrorComponent {

  constructor(){

  }

}



// WEBPACK FOOTER //
// ./src/app/404/error.component.ts